import React, { useEffect } from "react";
import "./security.css";
import data_security1 from "assets/security/data_security1.png";
import data_security2 from "assets/security/data_security2.png";
import data_security3 from "assets/security/data_security3.png";
import data_security4 from "assets/security/data_security4.png";
import data_security5 from "assets/security/data_security5.png";
import data_security6 from "assets/security/data_security6.png";
import data_security7 from "assets/security/data_security7.png";
import Meta from "utils/meta";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import TextBlock from "Component/TextBlock/textBlock";
import ImageWithTextBlock from "Component/ImageWithTextBlock/imageWithTextBlock";

const DataSecurityCompliance = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Data Security Compliance | The Realtor Desk" description="" />
        <div className="sub-page--outer">
          <SubPageHeader
              title="Safeguard Your Most Valuable Asset"
              subTitle="Protect your data from both internal and external threats, ensuring its security and integrity at all times."
          />
          <div className="container">
            <TextBlock
                shortTitle=""
                title="Real Estate Dual Data Security in Realtor CRM"
                description="Your data can be exposed in two ways: through employee leakage or cyber threats. Realtor CRM safeguards your most valuable asset from both. With its proprietary Dual Data Security system, it ensures that your data remains where it should be, protected from unauthorized access at all times."
                textSize="large"
            />
            <ImageWithTextBlock
                shortTitle="Safeguard Your Data with Advanced Encryption"
                title="Encryption to Protect Sensitive Real Estate Data in CRM"
                description="AES-256 (Advanced Encryption Standard) ensures that your sensitive real estate data is securely protected against leaks or loss. You can trust that only authorized individuals with the necessary access and permissions will be able to view this data, providing peace of mind and ensuring the highest level of security."
                image={data_security1}
                imagePosition="right"
            />
            <ImageWithTextBlock
                shortTitle="IP-Based Session Management"
                title="Enhance Security with IP-Based Access Control"
                description="The Realtor Desk allows you to restrict sign-ins to only pre-approved IP addresses, adding an extra layer of security. Even if a user's credentials are compromised, this feature ensures that your account and data remain protected by limiting access to trusted IPs."
                image={data_security2}
                imagePosition="left"
            />
            <ImageWithTextBlock
                shortTitle="VAPT Compliance"
                title="Complete Protection from Cyber Vulnerabilities"
                description="We’ve taken comprehensive steps to safeguard the platform and your data from cyber threats. Our Software Development Life Cycle (SDLC) adheres to secure coding guidelines and includes rigorous screening for potential security issues. Our robust security framework, based on OWASP standards, mitigates risks such as SQL injection, cross-site scripting, and application layer DoS attacks. Additionally, your service data is logically separated from other customers' data using secure protocols, ensuring that your data remains exclusively yours—Realtor has no access to it."
                image={data_security3}
                imagePosition="right"
            />
            <ImageWithTextBlock
                shortTitle="ISO 27001 Compliance & Certification"
                title="Trust in Our ISO Security Compliance"
                description="The Realtor Desk follows formal processes and security standards that meet industry, state, federal, and international regulations. We are proud to be ISO/IEC 27001:2013 certified, ensuring that your data is protected according to the highest security standards."
                image={data_security4}
                imagePosition="left"
            />
            <ImageWithTextBlock
                shortTitle="Regular Data Backups"
                title="Ensure Data Protection with Automated Backups"
                description="The Realtor Desk automatically backs up your data in real time across multiple servers, ensuring it remains protected at all times. With regular backups, you can have peace of mind knowing your data is safe and easily recoverable."
                image={data_security5}
                imagePosition="right"
            />
            <ImageWithTextBlock
                shortTitle="Track User Activity with Audit Logs"
                title="Monitor Team Actions for Enhanced Accountability"
                description="The Realtor Desk allows you to track user activity by generating detailed audit logs, enabling you to monitor actions taken by your team, such as records deleted by a user. This feature helps you maintain visibility over the flow of data within your team, ensuring accountability and allowing you to take preventive measures when necessary."
                image={data_security6}
                imagePosition="left"
            />
            <ImageWithTextBlock
                shortTitle="Strong Password Enforcements"
                title="Enhance Data Security with Password Policies"
                description="The Realtor Desk enforces strong password requirements to ensure that every team member uses high-quality passwords. Additionally, end-to-end encryption protects your data, both on the server and during password input, meeting banking-level security standards for maximum protection."
                image={data_security7}
                imagePosition="right"
            />
          </div>
      </div>
    </>
  );
};

export default DataSecurityCompliance;
